import { React, useState } from "react";

const OngoingProjects = () => {
  const [type, setType] = useState("EDAI");
  const domainList = ["Smart Education", "Smart City", "Healthcare"];
  const [currentDomain, setCurrentDomain] = useState(domainList[0]);

  return (
    <>
      <div className="flex flex-col justify-evenly p-14 bg-[#ECECEC] w-full h-screen">
        <h1 className="text-3xl text-[#1E1E4A] font-semibold">
          Ongoing Projects
        </h1>
        <div className="flex flex-col h-5/6">
          <div className="flex flex-row w-full h-16 mb-2 bg-white rounded-lg px-4 pt-4">
            <div className="flex flex-col place-items-center mr-10">
              <h1
                className="w-12 text-lg hover:cursor-pointer"
                onClick={() => setType("EDAI")}
              >
                EDAI
              </h1>
              {type === "EDAI" && <div className="h-1 w-12 bg-[#6767ce]"></div>}
            </div>
            <div className="flex flex-col place-items-center">
              <h1
                className="w-12 text-lg hover:cursor-pointer"
                onClick={() => setType("SDP")}
              >
                SDP
              </h1>
              {type === "SDP" && <div className="h-1 w-12 bg-[#6767ce]"></div>}
            </div>
          </div>
          <div className="flex flex-col w-full h-full bg-white rounded-lg">
            {type === "EDAI" && (
              <div className="flex flex-col h-full place-items-center justify-center text-xl font-medium">
                Not assigned yet!
              </div>
            )}
            {type === "SDP" && (
              <div className="flex flex-col h-full place-items-center p-4 px-20">
                <h1 className="text-xl">SDP 2021-22 Sem2</h1>
                <h1 className="text-lg text-red-600 mb-4">
                  Deadline: 28th May, 2022
                </h1>
                <div className="flex flex-row w-full h-1/2 my-4">
                  <div className="flex flex-col h-full w-1/5 bg-purple-100 rounded-2xl p-5">
                    <h1 className="text-gray-600 text-lg">TY CSA</h1>
                    <div className="w-full h-px bg-gray-400"></div>
                    <h1 className="text-purple-700 font-semibold mt-3">
                      Guide
                    </h1>
                    <h1 className="text-gray-500">Ashwini Shingare</h1>
                    <h1 className="text-purple-700 font-semibold mt-3">
                      Contributor
                    </h1>
                    <h1 className="text-gray-500">Avinash Vijayvargiya</h1>
                  </div>
                  <div className="flex flex-col w-full px-10">
                    <div class="relative z-0 w-full mb-4 group">
                      <input
                        type="email"
                        name="floating_email"
                        value={"DivyaShram"}
                        class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=" "
                        required
                      />
                      <label
                        for="floating_email"
                        class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Title
                      </label>
                    </div>
                    <div className="flex flex-row place-items-center mb-4">
                      <div className="mr-5">
                        <div className="pr-8 group">
                          <div className="group-hover:block inline-block relative">
                            <button className="bg-gray-200 text-gray-700 font-semibold py-2 px-4 rounded-full inline-flex justify-between items-center w-40">
                              <span className="mr-1">Domain</span>
                              <svg
                                className="fill-current h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                              </svg>
                            </button>
                            <ul className="group-hover:block absolute hidden text-gray-700 pt-1 w-40">
                              {domainList.map((type, index) => (
                                <li key={index}>
                                  <button
                                    className="bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap w-40"
                                    onClick={() =>
                                      setCurrentDomain(domainList[index])
                                    }
                                  >
                                    <div className="flex flex-row justify-between place-items-center">
                                      {type}
                                    </div>
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="mb-1 mr-1 px-2 border border-[#B2B7FF] rounded-full">
                        {currentDomain}
                      </div>
                    </div>
                    <div className="w-full h-10 ">
                      <textarea
                        id="message"
                        rows="4"
                        class="block p-1 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Description"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row place-items-center justify-center w-24 h-10 hover:cursor-pointer hover:bg-white bg-[#5C5CC0] text-white font-semibold hover:text-[#5C5CC0] mr-2 px-2 border border-[#5C5CC0] rounded-lg">
                  Save
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OngoingProjects;
